import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import { useNavbar } from "../contexts/NavbarContext";

const TopBanner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { showNavbar, toggleNavbar } = useNavbar();
  const navigate = useNavigate();
  const location = useLocation();

  const messages = [
    "Vous essayez, vous aimez, puis vous payez ❤️",
    " Livraison gratuite partout au Maroc 🇲🇦",
    "Retours gratuits sous 30 jours 🔄",
    "Fabrication artisanale 100% marocaine 🇲🇦",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % messages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [messages.length]);

  const navigateToNextPage = () => {
    // Utiliser l'historique du navigateur pour aller en avant
    if (window.history.length > 1) {
      window.history.forward();
    }
  };

  const navigateToPrevPage = () => {
    // Utiliser l'historique du navigateur pour aller en arrière
    if (window.history.length > 1) {
      window.history.back();
    }
  };



      return (
      <div
        style={{
          background: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(20px)",
          borderBottom: "1px solid rgba(212, 175, 55, 0.2)",
          padding: "8px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
          overflow: "hidden",
          minHeight: "40px",
        }}
      >
        <motion.button
          onClick={navigateToPrevPage}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          style={{
            background: "rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            border: "1px solid rgba(212, 175, 55, 0.3)",
            borderRadius: "50%",
            width: "28px",
            height: "28px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            color: "#2c1810",
            fontSize: "20px",
            fontWeight: "600",
            transition: "all 0.3s ease",
            zIndex: 2,
          }}
          onMouseEnter={(e) => {
            e.target.style.background = "rgba(212, 175, 55, 0.2)";
            e.target.style.borderColor = "#d4af37";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "rgba(255, 255, 255, 0.1)";
            e.target.style.borderColor = "rgba(212, 175, 55, 0.3)";
          }}
        >
          ‹
        </motion.button>

        <div
          style={{
            flex: 1,
            textAlign: "center",
            position: "relative",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <AnimatePresence mode="wait">
            <motion.p
              key={currentSlide}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              style={{
                margin: 0,
                fontSize: window.innerWidth <= 768 ? "13px" : "20px",
                fontWeight: "bold",
                color: "#2c1810",
                fontFamily: "'Cormorant Garamond', serif",
                letterSpacing: "0.5px",
                position: "absolute",
                width: "100%",
              }}
            >
              {messages[currentSlide]}
            </motion.p>
          </AnimatePresence>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {/* Bouton pour afficher/masquer la navbar */}
          <motion.button
            onClick={toggleNavbar}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            animate={showNavbar ? { 
              scale: [1, 1.05, 1],
              boxShadow: [
                "0 0 0 rgba(212, 175, 55, 0)",
                "0 0 20px rgba(212, 175, 55, 0.3)",
                "0 0 0 rgba(212, 175, 55, 0)"
              ]
            } : {}}
            transition={showNavbar ? { 
              duration: 2, 
              repeat: Infinity,
              ease: "easeInOut"
            } : {}}
            style={{
              background: showNavbar ? "rgba(212, 175, 55, 0.3)" : "rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(10px)",
              border: showNavbar ? "1px solid #d4af37" : "1px solid rgba(212, 175, 55, 0.3)",
              borderRadius: "50%",
              width: "28px",
              height: "28px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              color: showNavbar ? "#d4af37" : "#2c1810",
              fontSize: "16px",
              fontWeight: "600",
              transition: "all 0.3s ease",
              zIndex: 2,
            }}
            onMouseEnter={(e) => {
              if (!showNavbar) {
                e.target.style.background = "rgba(212, 175, 55, 0.2)";
                e.target.style.borderColor = "#d4af37";
              }
            }}
            onMouseLeave={(e) => {
              if (!showNavbar) {
                e.target.style.background = "rgba(255, 255, 255, 0.1)";
                e.target.style.borderColor = "rgba(212, 175, 55, 0.3)";
              }
            }}
            title={showNavbar ? "Menu visible" : "Afficher le menu"}
          >
            {showNavbar ? "✓" : "☰"}
          </motion.button>

          <motion.button
            onClick={navigateToNextPage}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            style={{
              background: "rgba(255, 255, 255, 0.1)",
              backdropFilter: "blur(10px)",
              border: "1px solid rgba(212, 175, 55, 0.3)",
              borderRadius: "50%",
              width: "28px",
              height: "28px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              color: "#2c1810",
              fontSize: "20px",
              fontWeight: "600",
              transition: "all 0.3s ease",
              zIndex: 2,
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "rgba(212, 175, 55, 0.2)";
              e.target.style.borderColor = "#d4af37";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "rgba(255, 255, 255, 0.1)";
              e.target.style.borderColor = "rgba(212, 175, 55, 0.3)";
            }}
          >
            ›
          </motion.button>
        </div>

        {/* Indicateurs de progression */}
        
        {/* Indicateur visuel pour la navbar */}
        {showNavbar && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            style={{
              position: "absolute",
              bottom: "-2px",
              left: "50%",
              transform: "translateX(-50%)",
              width: "20px",
              height: "3px",
              background: "linear-gradient(90deg, #d4af37, #b8860b)",
              borderRadius: "2px",
              boxShadow: "0 2px 8px rgba(212, 175, 55, 0.4)",
            }}
          />
        )}
      </div>
    );
  };

export default TopBanner;
